// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3cdd1ea7","488":"cbf5667e"}[chunkId] + ".chunk.js";
};